import React from "react";
import { CaretDownOutlined } from "@ant-design/icons";

type FAQItem = {
  question: string;
  answer?: string;
};

export const FAQSection: React.FC<{ faqs: FAQItem[] }> = ({ faqs }) => {
  const [openIndexes, setOpenIndexes] = React.useState<number[]>([]);

  const toggle = (idx: number) => {
    setOpenIndexes((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  return (
    <section className="mt-6 max-w-full bg-white rounded-xl shadow-sm w-[970px]">
      <div className="p-8 max-md:p-5">
        <h3 className="text-lg font-bold text-cyan-700 mb-4">FAQ</h3>

        <div className="divide-y divide-gray-200">
          {(faqs || []).map((faq, idx) => {
            const isOpen = openIndexes.includes(idx);

            return (
              <div key={idx} className="py-3">
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between text-left gap-3"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-medium text-gray-900">
                    {faq.question}
                  </span>

                  <CaretDownOutlined
                    className={`transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {/* Smooth expand/collapse (no layout jump) */}
                <div
                  className={`grid transition-all duration-200 ease-in-out ${
                    isOpen ? "grid-rows-[1fr] mt-2" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {faq.answer || "Answer not available."}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};